export const debounce = <F extends (...args: unknown[]) => unknown>(func: F, waitFor: number) => {
  let timeout: NodeJS.Timeout;

  return async (...args: Parameters<F>): Promise<ReturnType<F>> =>
    new Promise(resolve => {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => resolve(func(...args) as ReturnType<F>), waitFor);
    });
};

